
import { Navigate, useSearchParams } from 'react-router-dom';

export default function WixNavigate() {
    const [params] = useSearchParams()
    const path = params.get('path') || '/'
    return ( <Navigate to={path} replace={true} /> )
}